module.exports = __webpack_public_path__ + "img/knus_detail.090b99b4.jpg";